import React from 'react';
import clsx from 'clsx';
import {Typography} from '@mui/material';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {
	UserSelector,
	UserSelectorProps,
} from '@netx/core-user/components/UserSelector';
import {CUSTOM_ACTION_LABEL} from '../../locales';
import {
	customActionEditAccessClasses,
	getCustomActionEditAccessUtilityClass,
	CustomActionEditAccessClasses,
	CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME,
} from './customActionEditAccessClasses';

export type CustomActionEditAccessOwnerState = WithClasses<
	CustomActionEditAccessClasses,
	{}
>;

const useUtilityClasses = (ownerState: CustomActionEditAccessOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getCustomActionEditAccessUtilityClass, classes);
};

const CustomActionEditAccessRoot = styled('div', {
	name: CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({}));

const CustomActionEditAccessUserSelector = styled(UserSelector, {
	name: CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME,
	slot: 'Selector',
})(({theme}) => ({
	border: `1px solid ${theme.palette.custom.border}`,
	borderRadius: 8,
	margin: theme.spacing(1, 0),
}));

const CustomActionEditAccessLabel = styled(Typography, {
	name: CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME,
	slot: 'Label',
})(({theme}) => ({
	margin: theme.spacing(1, 0, 0, 1),
}));

export type CustomActionEditAccessProps = Omit<UserSelectorProps, 'classes'> &
	WithClasses<CustomActionEditAccessClasses, {}>;

export const CustomActionEditAccessPrimitive = ({
	classes: _classes,
	className,
	onChange,
	...props
}: CustomActionEditAccessProps) => {
	const ownerState: CustomActionEditAccessOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<CustomActionEditAccessRoot className={clsx(classes.root, className)}>
			<CustomActionEditAccessLabel noWrap variant="body1">
				{CUSTOM_ACTION_LABEL.ACCESS}
			</CustomActionEditAccessLabel>

			<CustomActionEditAccessUserSelector
				// must select something or we default to "all"
				disableNone
				// groups only
				disableUserSelection
				{...props}
				onChange={(userSelector) => {
					const _userSelector = {...userSelector};
					if (_userSelector.none === true) {
						_userSelector.none = false;
						_userSelector.all = true;
					}
					onChange(_userSelector);
				}}
			/>
		</CustomActionEditAccessRoot>
	);
};

export const CustomActionEditAccess = CustomActionEditAccessPrimitive;

export default CustomActionEditAccess;
